import React from 'react';
import {SurgicalProductsConstant} from './SurgicalProductsConstant';
import AlternatingLayout from '../shared-components/AlternatingLayout';
import { ProductCard } from '../productCard/ProductCard.jsx';
import sup23 from "../../assets/surgical-products/sup-23.png";

const SurgicalProducts = () => {
    return (
        <div className="surgical-products">
            <AlternatingLayout
                productDescription={"Our surgical products are designed to meet the highest standards of safety and performance in medical procedures. We offer a wide range of surgical instruments, sutures, drapes, and other essential supplies that are crafted from premium materials to ensure reliability and precision during surgeries. Our products are trusted by healthcare professionals worldwide for their quality and effectiveness."}
                data={SurgicalProductsConstant.dataSurgicalProducts}
                landScapeImg={false}
            />
            <div class="helmet-showcase">
             <ProductCard
                            title=" Surgical Products"
                            img={sup23}
                            landScapeImg={true}
                          />
                          </div>
                           <style>{`
        .helmet-showcase{display:flex;justify-content: center;margin-top: 10px;}
      `}</style>
        </div>
    );
};

export default SurgicalProducts;